import { render } from "./UserLevel.vue?vue&type=template&id=7923e2f7"
import script from "./UserLevel.vue?vue&type=script&lang=js"
export * from "./UserLevel.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__